import { useState } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

/**
 * Modal per visualizzare l'elenco delle VM con hostname e IP
 */
const VMListModal = ({ open, onClose, idLab, labType }) => {
    const [vmList, setVmList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchVMCharacteristics = async () => {
        try {
            setLoading(true);
            setError(null);

            // Prima ottieni il token dal backend
            const tokenResponse = await fetch(process.env.REACT_APP_URL_ELEARNING_TOKEN, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!tokenResponse.ok) {
                throw new Error(`Errore nel recupero del token: HTTP ${tokenResponse.status}`);
            }

            const tokenData = await tokenResponse.json();
            if (tokenData.status !== 'SUCCESS' || !tokenData.access_token) {
                throw new Error('Token non valido ricevuto dal server');
            }

            // Usa il token per la chiamata alle caratteristiche VM
            const response = await fetch(process.env.REACT_APP_URL_VM_CHARACTERISTICS, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${tokenData.access_token}`
                },
                body: JSON.stringify({ idLab: String(idLab), labType })
            });

            if (!response.ok) {
                throw new Error(`Errore HTTP ${response.status}`);
            }

            const result = await response.json();

            if (result.statusRequest === 'success' && result.data?.result) {
                setVmList(result.data.result);
            } else {
                throw new Error(result.status || 'Errore nel recupero dei dati');
            }
        } catch (err) {
            setError(err.message);
            setVmList([]);
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = () => {
        fetchVMCharacteristics();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth onTransitionEnter={handleOpen}>
            <DialogTitle>Elenco VM - Lab {idLab}</DialogTitle>
            <DialogContent sx={{ minHeight: '200px' }}>
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
                        <CircularProgress />
                    </Box>
                ) : vmList.length > 0 ? (
                    <TableContainer component={Paper} sx={{ mt: 1, maxHeight: 400 }}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Hostname</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Indirizzo IP</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {vmList.map((vm, index) => (
                                    <TableRow key={index} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#fafafa' } }}>
                                        <TableCell>{vm.dns_name || vm.name || '-'}</TableCell>
                                        <TableCell>{vm.agent_ipv4_address || '-'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : !error && (
                    <Typography sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
                        Nessuna VM trovata
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Chiudi</Button>
            </DialogActions>
        </Dialog>
    );
};

export default VMListModal;
